/**
 * Single source of truth for the public-facing app name.
 *
 * Internal code, storage keys, file paths, and type names still use the
 * code name "banana". Change this constant to swap the display name when
 * the app gets its official public release name.
 */
export const APP_DISPLAY_NAME = 'Banana';
